export default __webpack_public_path__ + "static/media/37-min.1026f66f.png";